<div class="container">
  <mat-card-header class="file_category_card_title">
    <mat-card-title class="file_category_card_title">{{"pages.file_upload.title" | translate}}</mat-card-title>
  </mat-card-header>

  <div mat-dialog-content>


    <div>
      <p class="m-0"><span class="primary">* </span>{{"pages.file_upload.subtitle" | translate}}</p>
      <div class="new_file_block mb-2">
        <ngx-file-drop dropZoneClassName="drop-zone" (onFileDrop)="documentDroped($event)" accept=".jpg, .jpeg, .png, .pdf, .xls, .xlsx, .doc, .docx, .ppt, .pptx, .zip, .csv, .xlsm">
          <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
            <div class="me-4">
              <mat-icon>upload</mat-icon>
            </div>
            <div class="me-4">
              <p class="drop-label line1">{{"pages.file_upload.drop_file_here" | translate }}</p>
              <p class="drop-label">{{"pages.file_upload.click_browse" | translate }}</p>
            </div>
            <button mat-raised-button type="button" (click)="openFileSelector()">{{"pages.file_upload.browse" | translate | uppercasefirstletter}}</button>
          </ng-template>
        </ngx-file-drop>
      </div>

      @if (documentsToUpload) {
      <mat-card-actions class="d-flex justify-content-between">
        <div class="dropped_file flex-grow-1">
          <div class="d-flex justify-content-center">
            <div class="file_name pointer">
              <span>{{documentsToUpload.fileEntry.name}}</span>
            </div>
            <button mat-icon-button (click)="removeDroppedDocument()"><mat-icon svgIcon="total-bin"></mat-icon></button>
          </div>
        </div>
      </mat-card-actions>
      }


      <p class="drop-label">{{"pages.file_upload.accepted_format" | translate }}</p>
      <p class="drop-label">{{"pages.file_upload.maximum_file_size" | translate }}</p>



    </div>

  </div>


  <div mat-dialog-actions style="margin-left: auto;width: fit-content; padding: 20px 0;margin-top: 20px" class="d-flex flex-end">
    <button style="width:120px; margin-right: 12px;" class="secondary-btn" mat-raised-button (click)="onNoClick()">
      <span class="grey">{{"messages.label.cancel" | translate}}</span>
    </button>
    <button (click)="uploadFile()" mat-raised-button style="width: fit-content; padding: 5px;" [disabled]="!documentsToUpload">
      {{"messages.label.validate" | translate}}
    </button>
  </div>

</div>